<template>
    <label class="btn btn-md font-sm font-weight-normal"
        :class="isChecked? ['btn-primary','text-white', 'active'] : ['btn-outline-primary','text-gray-dk']"
        :disabled="disabled">

        <input type="checkbox" autocomplete="off"
            :value="itemVal"
            :checked="isChecked"
            @click="toggleCheck($event)"
        /><slot></slot>
    </label>
</template>

<script>
    export default {
        props:{
            // model:{ default: () => [] },
            itemVal: { default: false },
            prevItems: { default: () => [] },
            disabled: { default: false, type: Boolean },
            checked: { default: false, type: Boolean },
            checkValue: { default: null }
        },
        data:() => {
            return {
                currStatus: false,
                multiSelect: []
            }
        },
        created: function() {
            this.multiSelect = this.prevItems
        },
        computed: {
            isChecked: function() {
                if(this.checkValue === null)
                    return this.currStatus
                else
                    return this.checkValue
            }
        },
        methods:{
            toggleCheck:function(event){
                this.currStatus = !this.currStatus;

                if (this.multiSelect.length && this.multiSelect.indexOf(event.target.value) < 0) {
                    var aler = this.multiSelect 
                    aler.push(event.target.value)
                    this.$emit('update:model', aler)
                } else
                    this.$emit('update:model', [event.target.value])

                this.$emit('doAction', this.currStatus)
            }
        }
    }
</script>

<style scoped>
    .btn {
        border: 1px solid #DEDEDE !important;
        border-radius: 0.1875rem !important;
        box-shadow: none !important;
    }
    
    /* hide checkbox  */
    .btn input[type=checkbox] {
        position: absolute;
        clip: rect(0, 0, 0, 0);
        pointer-events: none;
    }
</style>